window.OSP_MANUAL_DATA = {
  "manual": {
    "title": "G5 Wi-Fi Gateway manual",
    "hero_title": "G5 Wi-Fi Gateway",
    "product_family": "G5 Wi-Fi Gateway",
    "primary_app": "TTLock",
    "manual_version": "V26.1",
    "lead": "Set up your G5 in TTLock, read its status light and remove it from the app.",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/us/app/ttlock/id1033046018"
    },
    "checklist": [
      "Connect the G5 to its power supply.",
      "Open TTLock and have your 2.4 GHz or 5 GHz Wi-Fi name and password ready.",
      "Check for alternating red and blue before adding the gateway."
    ],
    "quick_specs": {
      "App": "TTLock",
      "Wi-Fi": "2.4 GHz or 5 GHz"
    },
    "search_placeholder": "Describe the problem — e.g. flashing red, won't add, Wi-Fi, delete gateway"
  },
  "guides": [
    {
      "handle": "g5-01",
      "title": "Indicator light status",
      "category": "Preparation",
      "steps": [
        "Connect the G5 gateway to its power supply.",
        "Observe the indicator color and flashing pattern.",
        "Compare the pattern with the status descriptions below."
      ],
      "notes": [
        "Red and blue flashing alternately: ready to be added and bound in TTLock.",
        "Red flashing: poor network connection; the gateway cannot communicate with the server.",
        "Blue flashing: normal working state; the gateway cannot be bound in this state."
      ],
      "warnings": [],
      "common_mistakes": [
        "Confusing alternating red and blue (ready to add) with flashing blue (normal working status, cannot be bound)."
      ],
      "summary": "Understand the meaning of different LED indicator light patterns on the G5 Smart Gateway.",
      "expected_result": "You can correctly identify whether the gateway is in ready state, has poor network connection, or is in normal working status based on the LED indicator behavior.",
      "images": [
        {
          "src": "us-manual-g5-01-1.webp",
          "alt": "G5 indicator: alternating red and blue means ready to add; flashing red means poor network; flashing blue means normal working state."
        }
      ]
    },
    {
      "handle": "g5-02",
      "title": "Bind the gateway to the app",
      "category": "App setup",
      "steps": [
        "Connect the gateway to its power supply.",
        "Open the \"TTLock\" APP on your smartphone.",
        "Tap the “+” button in the upper-right corner of the TTLock home screen.",
        "Select \"G5 (WI-FI)\" from the device list.",
        "Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\".",
        "When the G5 device appears in the search results, tap the \"+\" button next to it.",
        "Tap “WiFi Name” and select an available 2.4 GHz or 5 GHz Wi-Fi network.",
        "Enter your WiFi password accurately.",
        "Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\").",
        "Tap \"OK\" to complete the binding process.",
        "Wait for the gateway to automatically search for and connect to devices already bound in the APP."
      ],
      "notes": [
        "The G5 supports 2.4 GHz or 5 GHz Wi-Fi.",
        "Screenshots show example device names and network details. Use your own network password and gateway name."
      ],
      "warnings": [],
      "common_mistakes": [
        "Entering the wrong Wi-Fi password.",
        "Trying to add the gateway while the light flashes blue rather than red and blue alternately."
      ],
      "summary": "Connect the G5 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "expected_result": "The gateway searches for devices already bound in TTLock and displays connected devices.",
      "images": [
        {
          "src": "us-manual-g5-bind-01_2x.jpg",
          "alt": "TTLock home screen: tap + in the upper-right corner."
        },
        {
          "src": "us-manual-g5-bind-02_2x.jpg",
          "alt": "Add devices: select G5 (WI-FI)."
        },
        {
          "src": "us-manual-g5-bind-03_2x.jpg",
          "alt": "Add Gateway: tap Next when the indicator flashes red and blue alternately."
        },
        {
          "src": "us-manual-g5-bind-04_2x.jpg",
          "alt": "Choose Gateway: tap + next to the discovered G5."
        },
        {
          "src": "us-manual-g5-bind-05_2x.jpg",
          "alt": "Configure Network: select a 2.4 GHz or 5 GHz Wi-Fi network, then enter its password and a gateway name."
        },
        {
          "src": "us-manual-g5-bind-06_2x.jpg",
          "alt": "Configure Network: tap OK after entering your network details."
        },
        {
          "src": "us-manual-g5-bind-07_2x.jpg",
          "alt": "G5 scans for devices already bound in your TTLock account."
        },
        {
          "src": "us-manual-g5-bind-08_2x.jpg",
          "alt": "G5 displays the devices connected to this gateway."
        }
      ]
    },
    {
      "handle": "g5-03",
      "title": "Delete the gateway",
      "category": "Manage your gateway",
      "steps": [
        "Open TTLock and select the gateway you want to delete.",
        "Check the gateway name so you remove the correct device, then tap “Delete”.",
        "Confirm the deletion when prompted by the app."
      ],
      "notes": [
        "Deletion is a separate task, not part of initial setup."
      ],
      "warnings": [],
      "common_mistakes": [
        "Selecting the wrong gateway — check its name before deleting it.",
        "Leaving the confirmation unfinished — confirm the deletion in the app."
      ],
      "summary": "Remove the selected G5 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "expected_result": "The selected gateway is removed from your TTLock device list.",
      "images": [
        {
          "src": "us-manual-g5-delete-01_2x.jpg",
          "alt": "TTLock device list: select the G5 gateway you want to remove."
        },
        {
          "src": "us-manual-g5-delete-02_2x.jpg",
          "alt": "Selected gateway: check its name, then tap Delete."
        },
        {
          "src": "us-manual-g5-delete-03_2x.jpg",
          "alt": "Deletion prompt: confirm removal of the selected gateway."
        }
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "g5-red-light",
      "title": "Flashing red — poor network connection",
      "category": "Network",
      "explanation": "The G5 light guide identifies flashing red as poor network connectivity: the gateway cannot communicate with the server.",
      "symptoms": [
        "The gateway indicator flashes red."
      ],
      "quick_checks": [
        "Check your router and internet connection.",
        "During setup, choose an available 2.4 GHz or 5 GHz Wi-Fi network and check the password entered in TTLock."
      ],
      "fix_steps": [
        "Compare your setup with “Bind the gateway to the app” below.",
        "If the light continues flashing red, contact support with the light pattern and the app screen where you are stuck."
      ],
      "related_guides": [
        "g5-01",
        "g5-02"
      ],
      "support_evidence": [
        "Light color and flashing pattern",
        "Router model and whether your chosen network is 2.4 GHz or 5 GHz",
        "App screenshot with any password hidden"
      ]
    },
    {
      "handle": "g5-wont-add",
      "title": "Gateway won’t add in TTLock",
      "category": "App setup",
      "symptoms": [
        "The G5 does not finish adding to the app."
      ],
      "quick_checks": [
        "Use TTLock and choose G5 (WI-FI).",
        "The indicator must flash red and blue alternately before you tap Next.",
        "Choose an available 2.4 GHz or 5 GHz Wi-Fi network and check its password."
      ],
      "fix_steps": [
        "Follow the illustrated binding guide and tap + next to the discovered G5.",
        "Enter the Wi-Fi details and gateway name, then tap OK.",
        "If you cannot reach the documented ready state or setup still fails, contact support."
      ],
      "related_guides": [
        "g5-02",
        "g5-01"
      ],
      "support_evidence": [
        "Screenshot of the stage where adding stops",
        "Light color and pattern",
        "Phone model and TTLock version"
      ]
    },
    {
      "handle": "g5-flashing-blue",
      "title": "Flashing blue — is the gateway ready to add?",
      "category": "Status light",
      "explanation": "The G5 manual describes flashing blue as normal working state. The gateway cannot be bound in this state.",
      "symptoms": [
        "The light is flashing blue when you try to add the gateway."
      ],
      "quick_checks": [
        "The ready-to-add signal is alternating red and blue, not flashing blue."
      ],
      "fix_steps": [
        "If you only want to check the gateway is working, use the light-status guide.",
        "If you intend to remove a gateway from your account, follow the deletion guide.",
        "Contact support if you cannot access the gateway in TTLock or are unsure which device to remove."
      ],
      "related_guides": [
        "g5-01",
        "g5-03"
      ],
      "support_evidence": [
        "Gateway name shown in TTLock",
        "Light color and pattern",
        "What you are trying to do: check status, add or remove"
      ]
    },
    {
      "handle": "g5-delete-help",
      "title": "Need help deleting the gateway?",
      "category": "Manage your gateway",
      "symptoms": [
        "You need to remove a G5 gateway from TTLock."
      ],
      "quick_checks": [
        "Check the name of the gateway you have selected."
      ],
      "fix_steps": [
        "Select the gateway, tap Delete, then confirm the deletion.",
        "If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown."
      ],
      "related_guides": [
        "g5-03"
      ],
      "support_evidence": [
        "Screenshot of the selected gateway or error",
        "TTLock app version",
        "Whether the confirmation completed"
      ]
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Gateway won’t add or flashes red",
      "subject": "G5 Wi-Fi Gateway — setup or network help",
      "body": "Hi Blusafe team,\n\nI need help with my G5 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nStep where I am stuck: \nLight color and pattern: \nSelected network band (2.4 GHz or 5 GHz): \nRouter model: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    },
    {
      "title": "Help removing a gateway",
      "subject": "G5 Wi-Fi Gateway — removal help",
      "body": "Hi Blusafe team,\n\nI need help with my G5 Wi-Fi Gateway.\n\nOrder number: \nPhone model: \nTTLock version: \nGateway name: \nWhat happens after tapping Delete: \nDid the confirmation complete?: \nMessage shown in TTLock: \n\nI have attached a screenshot of the relevant app screen and, if useful, a short video of the indicator. I have hidden any passwords.\n\nThanks,\n[Your name]"
    }
  ],
  "support_email": "enquiries@blusafesolutions.com",
  "search_index": [
    {
      "title": "Indicator light status",
      "type": "guide",
      "category": "Preparation",
      "anchor": "g5-01",
      "summary": "Understand the meaning of different LED indicator light patterns on the G5 Smart Gateway.",
      "keywords": "Connect the G5 gateway to its power supply. Observe the indicator color and flashing pattern. Compare the pattern with the status descriptions below. Red and blue flashing alternately: ready to be added and bound in TTLock. Red flashing: poor network connection; the gateway cannot communicate with the server. Blue flashing: normal working state; the gateway cannot be bound in this state. Confusing alternating red and blue (ready to add) with flashing blue (normal working status, cannot be bound)."
    },
    {
      "title": "Bind the gateway to the app",
      "type": "guide",
      "category": "App setup",
      "anchor": "g5-02",
      "summary": "Connect the G5 Smart Gateway to the TTLock APP and configure it for use with your WiFi network.",
      "keywords": "Connect the gateway to its power supply. Open the \"TTLock\" APP on your smartphone. Tap the “+” button in the upper-right corner of the TTLock home screen. Select \"G5 (WI-FI)\" from the device list. Verify the gateway indicator is flashing red and blue alternately, then tap \"Next\". When the G5 device appears in the search results, tap the \"+\" button next to it. Tap “WiFi Name” and select an available 2.4 GHz or 5 GHz Wi-Fi network. Enter your WiFi password accurately. Enter a recognizable name for your Gateway (e.g., \"Living Room Gateway\"). Tap \"OK\" to complete the binding process. Wait for the gateway to automatically search for and connect to devices already bound in the APP. The G5 supports 2.4 GHz or 5 GHz Wi-Fi. Screenshots show example device names and network details. Use your own network password and gateway name. Entering the wrong Wi-Fi password. Trying to add the gateway while the light flashes blue rather than red and blue alternately."
    },
    {
      "title": "Delete the gateway",
      "type": "guide",
      "category": "Manage your gateway",
      "anchor": "g5-03",
      "summary": "Remove the selected G5 gateway from your TTLock account. This task is only needed when you want to delete a gateway.",
      "keywords": "Open TTLock and select the gateway you want to delete. Check the gateway name so you remove the correct device, then tap “Delete”. Confirm the deletion when prompted by the app. Deletion is a separate task, not part of initial setup. Selecting the wrong gateway — check its name before deleting it. Leaving the confirmation unfinished — confirm the deletion in the app."
    },
    {
      "title": "Flashing red — poor network connection",
      "type": "troubleshooting",
      "category": "Network",
      "anchor": "g5-red-light",
      "summary": "The G5 light guide identifies flashing red as poor network connectivity: the gateway cannot communicate with the server.",
      "keywords": "Check your router and internet connection. During setup, choose an available 2.4 GHz or 5 GHz Wi-Fi network and check the password entered in TTLock. Compare your setup with “Bind the gateway to the app” below. If the light continues flashing red, contact support with the light pattern and the app screen where you are stuck. The gateway indicator flashes red."
    },
    {
      "title": "Gateway won’t add in TTLock",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "g5-wont-add",
      "summary": "The G5 does not finish adding to the app.",
      "keywords": "Use TTLock and choose G5 (WI-FI). The indicator must flash red and blue alternately before you tap Next. Choose an available 2.4 GHz or 5 GHz Wi-Fi network and check its password. Follow the illustrated binding guide and tap + next to the discovered G5. Enter the Wi-Fi details and gateway name, then tap OK. If you cannot reach the documented ready state or setup still fails, contact support. The G5 does not finish adding to the app."
    },
    {
      "title": "Flashing blue — is the gateway ready to add?",
      "type": "troubleshooting",
      "category": "Status light",
      "anchor": "g5-flashing-blue",
      "summary": "The G5 manual describes flashing blue as normal working state. The gateway cannot be bound in this state.",
      "keywords": "The ready-to-add signal is alternating red and blue, not flashing blue. If you only want to check the gateway is working, use the light-status guide. If you intend to remove a gateway from your account, follow the deletion guide. Contact support if you cannot access the gateway in TTLock or are unsure which device to remove. The light is flashing blue when you try to add the gateway."
    },
    {
      "title": "Need help deleting the gateway?",
      "type": "troubleshooting",
      "category": "Manage your gateway",
      "anchor": "g5-delete-help",
      "summary": "You need to remove a G5 gateway from TTLock.",
      "keywords": "Check the name of the gateway you have selected. Select the gateway, tap Delete, then confirm the deletion. If the app differs from the illustrated guide or deletion does not complete, contact support with the message shown. You need to remove a G5 gateway from TTLock."
    }
  ]
};
